export const SYSTEM_USER_USER_ID = 'bc93acc0-6661-4669-86a5-3cd57898a13b';
export const COTERA_DEMO_ORG_ID = '72bedf67-b727-42c3-9873-ac9d4ef74293';
